var EventEmitter = function() {
    this.listeners = [];
}

EventEmitter.prototype.addListener = function(listener) {
    if(listener) {
        let idx = this.listeners.indexOf(listener);
        if(idx === -1) {
            this.listeners.push(listener);
        }
    }
}

EventEmitter.prototype.removeListener = function(listener) {
    if(listener) {
        let idx = this.listeners.indexOf(listener);
        if(idx !== -1) {
            this.listeners.splice(idx, 1);
        }
    }
}

EventEmitter.prototype.emit = function() {
    let args = arguments;
    this.listeners.forEach(function(listener) {
        listener.apply(null, args);
    })
}

module.exports = {
    "EventEmitter" : EventEmitter
};
